import { CardSuggestion } from "./card-suggestion.model";

export class CardSuggestionTranslation{
    /*
    *
    */
    constructor(
      public id?:  number,
      public title?: string,
      public location?: string,
      public details?: string,
      public link?: string,
      public locale?: string,
      public cardSuggestions?: CardSuggestion
    ){}
}